import React from "react";
import { painelService } from "../../../services/painelService";

export interface TemposEtapasBadgesProps {
  displayId: number;
  /** Salão FoodFly com mesa/comanda: não mostrar Pedido #. */
  hidePedidoId?: boolean;
  aguardandoMontagemSeg?: number | null;
  emMontagemSeg?: number | null;
  emFornoSeg?: number | null;
  aguardandoEntregaSeg?: number | null;
  emEntregaSeg?: number | null;
}

function fmt(s: number | null | undefined): string {
  if (s == null || s < 0) return "";
  return painelService.formatSegundosParaBadge(s);
}

const LINHAS: {
  key: keyof Omit<TemposEtapasBadgesProps, "displayId" | "hidePedidoId">;
  label: string;
}[] = [
  { key: "aguardandoMontagemSeg", label: "Aguardando montagem" },
  { key: "emMontagemSeg", label: "Em montagem" },
  { key: "emFornoSeg", label: "Em forno" },
  { key: "aguardandoEntregaSeg", label: "Aguardando entrega" },
  { key: "emEntregaSeg", label: "Em entrega" },
];

export const TemposEtapasBadges: React.FC<TemposEtapasBadgesProps> = (
  props
) => {
  const valores = {
    aguardandoMontagemSeg: props.aguardandoMontagemSeg,
    emMontagemSeg: props.emMontagemSeg,
    emFornoSeg: props.emFornoSeg,
    aguardandoEntregaSeg: props.aguardandoEntregaSeg,
    emEntregaSeg: props.emEntregaSeg,
  };
  const linhasComValor = LINHAS.filter(
    (l) =>
      valores[l.key] != null &&
      valores[l.key] !== undefined &&
      (valores[l.key] as number) >= 0
  );
  if (linhasComValor.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5 rounded-lg border border-slate-200 bg-slate-50/80 px-3 py-2.5 text-xs">
      {!props.hidePedidoId ? (
        <span className="font-semibold text-slate-700">
          Pedido #{props.displayId}
        </span>
      ) : null}
      {linhasComValor.map(({ key, label }) => (
        <span key={key} className="leading-relaxed text-slate-600">
          {label}:{" "}
          <strong className="text-slate-800">{fmt(valores[key])}</strong>
        </span>
      ))}
    </div>
  );
};
